<h1 mat-dialog-title class="form-title">端末情報</h1>

<div mat-dialog-content>
  <form (ngSubmit)="onSubmit()" class="terminal-form" #terminalForm="ngForm">
    <section *ngIf="isNew">
      <mat-checkbox placeholder="test" [(ngModel)]="keySet.isPWA" (change)="setRandomSerial()" id="isPWA" name="isPWA" #isPWA="ngModel">携帯打刻端末</mat-checkbox>
    </section>
    <mat-form-field>
      <input matInput placeholder="端末名" id="terminalName" [(ngModel)]="keySet.name" name="terminalName" #terminalName="ngModel"
        required>
      <mat-error *ngIf="terminalName.errors?.required">端末名の入力は必須です</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="営業日変更時間" id="borderHour" [(ngModel)]="keySet.borderHour" name="borderHour"
        #borderHour="ngModel" required>
      <mat-error *ngIf="borderHour.errors?.required">営業日変更時間の入力は必須です</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="シリアル番号" id="serialId" [(ngModel)]="keySet.serialId" [disabled]="keySet.isPWA" name="serialId" #serialId="ngModel"
        required>
      <mat-error *ngIf="serialId.errors?.required">シリアル番号の入力は必須です</mat-error>
    </mat-form-field>
    <mat-form-field>
      <input matInput placeholder="就業役者端末識別ID" id="yakusyaTerminalId" [(ngModel)]="keySet.yakusyaTerminalId" name="yakusyaTerminalId" #yakusyaTerminalId="ngModel" >
    </mat-form-field>

    <span>
      <button type="button" mat-raised-button (click)="onCancel()">キャンセル</button>
      <button type="submit" mat-raised-button color="primary" [disabled]="terminalForm.invalid || submitting">登録</button>
    </span>
  </form>
</div>
